var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20zm9.843-28.838c.056.06.095.135.113.216.034.142.049.288.043.435-.001.078-.008.153-.015.242l-.015.186c-.117 1.88-3.628 15.91-3.628 15.91a1.122 1.122 0 01-.348.573 1.138 1.138 0 01-.615.275 1.391 1.391 0 01-1.008-.385c-.793-.677-2.63-1.972-4.34-3.143a42.23 42.23 0 00-2.61 2.373c-1.51 1.498-1.316 0-1.316 0l.464-4.814a.181.181 0 01.066-.161l.157-.14c1.193-1.058 8.756-7.769 8.974-8.53.018-.068-.052-.095-.144-.068-.595.216-10.831 6.634-11.96 7.342a.545.545 0 01-.253.015l-4.968-1.607s-.593-.234-.402-.78c.04-.112.119-.207.355-.371 1.101-.762 20.377-7.638 20.377-7.638.278-.097.577-.118.866-.06.08.024.15.069.207.13z",
    fill: "#000",
    className: "hover"
  })));
}
export default SvgTelegramIconDark;